"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorProductsCsv = void 0;
const routes_1 = require("../../routes");
const getDistributorProductsCsv = (client) => async (params) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ALL_PARTNER_PRODUCTS.applyParams(params));
    return response.data;
};
exports.getDistributorProductsCsv = getDistributorProductsCsv;
